import React, { useEffect } from 'react';

export default function useWindowLocation () {
  const [location, setLocation] = React.useState(window.location);
  const [pathname, setPathname] = React.useState(window.location.pathname);
  const [hash, setHash] = React.useState(window.location.hash);
  const [protocol, setProtocol] = React.useState(window.location.protocol);

  const listenToPopstate = () => {
    setPathname(window.location.pathname);
    setHash(window.location.hash);
    setProtocol(window.location.protocol);
    setLocation(window.location);
  };

  useEffect(() => {
    window.addEventListener('popstate', listenToPopstate);

    return () => {
      window.removeEventListener('popstate', listenToPopstate);
    };
  }, []);

  return {
    location,
    pathname,
    hash,
    protocol
  };
}
